import { defineStore } from 'pinia';
import { ref } from 'vue';

export type Theme = 'light' | 'dark' | 'system';
const STORAGE_KEY = 'quark-vault-theme';

export const useThemeStore = defineStore('theme', () => {
  const current = ref<Theme>('light');
  const resolved = ref<'light' | 'dark'>('light');
  let media: MediaQueryList | undefined;

  function render() {
    resolved.value = current.value === 'system' && media?.matches ? 'dark' : current.value === 'dark' ? 'dark' : 'light';
    document.documentElement.dataset.theme = resolved.value;
    document.body.setAttribute('arco-theme', resolved.value);
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', resolved.value === 'dark' ? '#08090c' : '#f5f7fa');
  }

  function apply(value: Theme) {
    current.value = value;
    localStorage.setItem(STORAGE_KEY, value);
    render();
  }

  function initialize() {
    media = window.matchMedia('(prefers-color-scheme: dark)');
    media.addEventListener('change', render);
    const saved = localStorage.getItem(STORAGE_KEY) as Theme | null;
    apply(saved && ['light', 'dark', 'system'].includes(saved) ? saved : 'system');
  }

  function toggle() { apply(resolved.value === 'light' ? 'dark' : 'light'); }
  return { current, resolved, apply, initialize, toggle };
});
